import addStaticMembersTo
import buildValues
import dev.shanty.kotwire.stimulus.Application
import dev.shanty.kotwire.stimulus.Event
import kotlin.Boolean
import kotlin.String
import kotlin.js.JsExport
import kotlin.reflect.KClass
import org.w3c.dom.HTMLElement

@JsExport
public interface ConfirmControllerTargetLifecycleHooks {
  public fun messageValueChanged(`value`: String, previousValue: String) {
  }
}

public fun ConfirmController.messageValue(): StimulusProperty<String> =
    StimulusProperty("messageValue")

public fun ConfirmController.hasMessageValue(): Boolean {
  println(this.asDynamic()["hasMessageValue"])
  return this.asDynamic()["hasMessageValue"]
}

public fun registerConfirmController(stimulus: Application) {
   val clazz = ConfirmController::class
   val properties = object  {
      // Js name needed otherwise Kotlin will mangle the name
      @JsName("targets")
      val targets = js("[]")

      @JsName("values")
      val values = buildValues(
          setOf(
              ValueDefinition("message", "String", false)
          ),
          ConfirmController.Values
      )
      
      
      
      @JsName("classes")
      val classes = js("[]")
  }

  val factoryFunc = clazz.js.asDynamic()

  addStaticMembersTo(factoryFunc, properties)
  val controllerName = "confirm"
  println("Registering controller confirm")

  stimulus.register(controllerName, factoryFunc)
}
